import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const links = t.footer.links;

  return (
    <footer
      data-testid="footer-section"
      className="relative bg-[#1B2A4A] text-white"
    >
      {/* Subtle texture */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 items-start">
          <div>
            <p className="font-serif text-2xl md:text-3xl font-bold tracking-tight">
              nagysandorweb<span className="text-[#3B82F6]">.com</span>
            </p>
            <p className="mt-4 text-sm text-white/60 leading-relaxed font-light max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
              {t.footer.contactLabel}
            </p>
            <a
              href="tel:+36203197459"
              className="block font-serif text-lg text-white hover:text-[#3B82F6] transition-colors duration-300"
            >
              +36 20 319 7459
            </a>
            <a
              href="mailto:nagys9908@gmail.com"
              className="block mt-1 text-sm text-white/70 hover:text-[#3B82F6] transition-colors duration-300"
            >
              nagys9908@gmail.com
            </a>
          </div>

          <div className="md:text-right">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
              {t.footer.navLabel}
            </p>
            <div className="flex flex-col gap-2 md:items-end text-sm text-white/70">
              <a href="#rolam" className="hover:text-[#3B82F6] transition-colors duration-300">
                {links.about}
              </a>
              <a href="#szolgaltatasok" className="hover:text-[#3B82F6] transition-colors duration-300">
                {links.services}
              </a>
              <a href="#portfolio" className="hover:text-[#3B82F6] transition-colors duration-300">
                {links.portfolio}
              </a>
              <a href="#kapcsolat" className="hover:text-[#3B82F6] transition-colors duration-300">
                {links.contact}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p
            data-testid="footer-copyright"
            className="text-xs md:text-sm text-white/50 tracking-wide"
          >
            {t.footer.copyright}
          </p>
          <p className="text-xs text-white/40 tracking-wide">{t.footer.credit}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
